__turbopack_context__.v({
  "svg_container": "styles-module-scss-module__4UFH7q__svg_container",
});
